import { render, staticRenderFns } from "./YBBkstep1.vue?vue&type=template&id=628c2441&"
import script from "./YBBkstep1.vue?vue&type=script&lang=js&"
export * from "./YBBkstep1.vue?vue&type=script&lang=js&"
import style0 from "./YBBkstep1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./YBBkstep1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports